import { render, staticRenderFns } from "./customerPrompt.vue?vue&type=template&id=c81d1cf8&scoped=true&"
import script from "./customerPrompt.vue?vue&type=script&lang=js&"
export * from "./customerPrompt.vue?vue&type=script&lang=js&"
import style0 from "./customerPrompt.vue?vue&type=style&index=0&id=c81d1cf8&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c81d1cf8",
  null
  
)

export default component.exports